"use client";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between" style={{height: "64px"}}>
        {/* Logo — nav-only version (icon + wordmark, no tagline) */}
        <a href="/" className="flex items-center shrink-0">
          <img src="/logo-nav.png" alt="SolarPipeline" style={{height: "40px", width: "auto"}} />
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#how-it-works" className="text-sm text-gray-500 hover:text-gray-900 font-medium transition-colors">
            How It Works
          </a>
          <a href="#who-its-for" className="text-sm text-gray-500 hover:text-gray-900 font-medium transition-colors">
            Who It&apos;s For
          </a>
          <a href="#faq" className="text-sm text-gray-500 hover:text-gray-900 font-medium transition-colors">
            FAQ
          </a>
          <a
            href="#qualify"
            className="bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-md transition-all duration-200 inline-block px-5 py-2.5 text-sm"
          >
            Book a Strategy Call
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-gray-700"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          <a href="#how-it-works" onClick={() => setOpen(false)} className="text-sm text-gray-600 font-medium">
            How It Works
          </a>
          <a href="#who-its-for" onClick={() => setOpen(false)} className="text-sm text-gray-600 font-medium">
            Who It&apos;s For
          </a>
          <a href="#faq" onClick={() => setOpen(false)} className="text-sm text-gray-600 font-medium">
            FAQ
          </a>
          <a
            href="#qualify"
            onClick={() => setOpen(false)}
            className="bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-md transition-all duration-200 inline-block px-8 py-3 text-sm text-center"
          >
            Book a Strategy Call
          </a>
        </div>
      )}
    </nav>
  );
}
